module.exports = __webpack_public_path__ + "img/candado.84687ffa.svg";